import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { forkJoin, Observable, of, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { DynamictagsInlineComponent, SearchAgGrid } from '../../../../../../bodisplay';
import { Select, EtatDoc, FileModel, BObjectModel, QueovalItem, Corporation, QResult, BObjectSummary, HtmlBase, QueovalParam, BreadcrumbModel, QueovalBase, QueovalItemModel, ModeFacturationModel, BreadDik, Facture } from '../../../../../../models';
import { StageDocumentUpdate } from '../../../../../../models/formation';
import { CalculConventionData, ClientConvention, ConventionApprenantData, ConventionData, ConventionModel, ConventionStageData } from '../../../../../../models/formation/convention.models';
import { BreadcrumbService, CoreService, FilesManagerService, HttpService, ModeFacturationService } from '../../../../../../services';
import { ToastService } from '../../../../../../toast';
import { StageService } from '../../../services/stage-modal.service';
import { ConventionService } from '../../convention.service';

@Component({
  selector: 'queoval-corps-convention',
  templateUrl: './corps-convention.component.html',
  styleUrls: ['./corps-convention.component.css', '../../convention.component.css']
})

export class CorpsConventionComponent implements OnInit {

  @ViewChild('dynamictagsInline') dynamictagsInline: DynamictagsInlineComponent;

  @Input() client: ClientConvention;
  @Input() convention: ConventionData;
  @Input('index') i: number;

  constructor(
    public http: HttpService,
    public indParam: CoreService,
    private conventionService: ConventionService,
    private fileService: FilesManagerService,
    private modalService: NgbModal,
    public stageService: StageService,
    private cd: ChangeDetectorRef,
    private breadCrumb: BreadcrumbService,
    private route: ActivatedRoute,
    private toast: ToastService,
    private facturationservice: ModeFacturationService,
  ) { }

  /** liste de la combo de DossiDOC */
  public get dossiers() {
    return this.conventionService.dossiers;
  }
  public get EntiteFact() {
    return this.conventionService.EntiteFact;
  }

  /** enum des EtatDoc */
  public etatDOC: typeof EtatDoc = EtatDoc;

  /** BO pour la modification/insertion du document (avec REL_BO_STAGE_BO_CVT, idDonneeFils, et mode BoHidden)*/
  public insertDocModel: BObjectModel;
  /** BO pour l'affichage du bBO_CVT (avec BO_CVT, showSaveButton, idDonneeFils) */
  public modelBOConvention: BObjectModel = new BObjectModel();
  /** BO pour l'affichage du financeur */
  public modelBOFinanceur: BObjectModel = new BObjectModel();
  /** BO pour l'affichage du responsable d'inscription */
  public modelBORespInscription: BObjectModel = new BObjectModel();
  public indexConvToDelete: number = -1;
  /** BO pour la recherche avancee du financeur */
  public modelForQSearch: SearchAgGrid;
  public modelBORechercheFinanceur: BObjectModel = new BObjectModel();

  /** E-signature */
  public boConvention: string = '0';
  public idConvention: string;
  public mode: string = 'ALL';

  //liste des apprenants pour le stage (à l'init)
  public apprenants: Array<QueovalItem> = [];
  public popoverWidth: number = 0;

  public ngOnInit(): void {
    this.convention.Apprenants.sort((a: QueovalItem, b: QueovalItem) => a.Text.toLowerCase().localeCompare(b.Text.toLowerCase()));
    this.apprenants = JSON.parse(JSON.stringify(this.convention.Apprenants));

    this.convention.Stages.forEach(stg => {
      if (stg.Selected) {
        stg.Apprenants.forEach(stgApp => {
          if (!this.convention.Apprenants.some(app => app.Value == stgApp.Value)) {
            this.convention.Apprenants.push(stgApp);
          }
        });
      }
    });

    //#region Init BO_CVT
    this.modelBOConvention = new BObjectModel();
    this.modelBOConvention.IdentBO = "BO_CVT";
    this.modelBOConvention.ShowSaveButton = true;
    //#endregion

    //#region Init BO_Financeur
    this.modelBOFinanceur = new BObjectModel();
    this.modelBOFinanceur.IdentBO = "BO_CSOC";
    this.modelBOFinanceur.ShowSaveButton = true;
    //#endregion

    //#region Init BO_DIRIGEANT
    this.modelBORespInscription = new BObjectModel();
    this.modelBORespInscription.IdentBO = "BO_DIRIGEANT";
    this.modelBORespInscription.IdentBODisplay = "BO_CONTACT";
    this.modelBORespInscription.ShowSaveButton = true;
    //#endregion

    //#region Init BO insertDoc
    this.insertDocModel = new BObjectModel();
    this.insertDocModel.IdRelation = "REL_BO_STAGE_BO_CVT";
    //#endregion

    //#region Init model recherche grid
    this.modelForQSearch = new SearchAgGrid();
    this.modelForQSearch.CodeRelation = "REL_FINANCEUR_BO_CVT";
    this.modelForQSearch.IdDonnee = this.convention.Ident;
    this.modelForQSearch.IdBo = "BO_CSOC";
    this.modelForQSearch.Mode = "LINK_REPLACE";
    this.modelForQSearch.Origin = "PERE";
    this.modelForQSearch.ColumnNameToDisplay = "RaisoCLI";
    //#endregion
  }


  /**
   * Suppression d'une convention
   * @param cvt
   * @param pIndex
   */
  public OnDelete(modal: NgbModalRef): void {
    if (!this.convention) {
      modal.dismiss();
      return;
    }
    if (this.convention.Factures?.length > 0) {
      this.toast.showWarningToast('Impossible de supprimer cette convention car une ou plusieurs factures y sont liées');
      modal.dismiss();
      return;
    }
    //Si la convention n'a pas encore d'ident on la retire de la liste des conventions
    //sans faire d'appel serveur
    if (!this.convention.Ident || this.convention.Ident == '0') {
      this.client.Conventions.splice(this.indexConvToDelete, 1);
      modal.dismiss();
      return;
    }
    //suppression en BDD
    this.client.Conventions[this.indexConvToDelete].deleting = true;
    this.http.postHttp<QResult<CalculConventionData>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/DELETE_CONVENTION`, this.convention).subscribe((result: QResult<CalculConventionData>) => {
      this.client.Conventions[this.indexConvToDelete].deleting = false;
      if (!result.HasError && !result.HasAlert) {
        this.client.MontantConventions = result.Value.MontantConvention;
        //puis si pas d'erreur retrait de la liste des conventions
        this.client.Conventions.splice(this.indexConvToDelete, 1);
        // compte le nombre de conventions sauvegardées
        this.client.NbConventions = this.client?.Conventions ? this.client.Conventions.filter(c => c.Ident && c.Ident != '0').length : 0;
      }
      modal.close();
    });
  }

  /**
   * Sauvegarde d'une convention
   * @param pClient: ClientConvention
   * @param pConvention convention
   * @param pIndex index dans la liste des conventions du client
   * @param pGeneration booléen pour la génération du document
   */
  public OnSave(pClient: ClientConvention, pIndex: number, pGeneration: boolean): void {
    if (!pClient.Conventions[pIndex] || (pGeneration && (pClient.Conventions[pIndex].CodeEtatDoc == this.etatDOC.SIGNE || pClient.Conventions[pIndex].CodeEtatDoc == this.etatDOC.ANNULE)))
      return;

    //#region controle ident facturation non vide
    if (!pClient.Conventions[pIndex].IdEntiteFact || pClient.Conventions[pIndex].IdEntiteFact == '0') {
      this.toast.showWarningToast('Veuillez saisir une entité de facturation valide.');
      return;
    }
    //#endregion

    if (!this.dynamictagsInline.HasEmptyProp()) {
      //#region création du modèle
      const model: ConventionData = JSON.parse(JSON.stringify(pClient.Conventions[pIndex]));
      model.Stages = model.Stages.filter(stage => stage.Selected);
      model.Apprenants = model.Apprenants.filter(apprenant => apprenant.Selected);
      model.Responsables = model.Responsables.filter(responsable => responsable.Selected);
      model.IdClientLinked = pClient.Ident;
      model.IdStageLinked = this.stageService.Stage.Ident;
      //#endregion

      //#region loader sur bouton : true
      if (pGeneration) pClient.Conventions[pIndex].generating = true;
      else pClient.Conventions[pIndex].saving = true;
      //#endregion
      this.http.postHttp<QResult<CalculConventionData>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/SAVE_CONVENTION`, model).subscribe((result: QResult<CalculConventionData>) => {

        if (!result.HasError) {
          //#region sauvegarde des propriétés obligatoires après création de la convention
          this.dynamictagsInline.idDonnee = result.Value.Convention.Ident;
          this.cd.detectChanges();
          this.dynamictagsInline.OnSave().subscribe((requiredPropsSaved: boolean) => {

            result.Value.Convention.Apprenants = result.Value.Convention.Apprenants.concat(pClient.Conventions[pIndex].Apprenants
              .filter(app => !result.Value.Convention.Apprenants.find(selected => selected.Value == app.Value))
              .map(stg => {
                stg.Selected = false;
                return stg;
              }));

            result.Value.Convention.Responsables = result.Value.Convention.Responsables.concat(pClient.Conventions[pIndex].Responsables
              .filter(resp => !result.Value.Convention.Responsables.find(selected => selected.Value == resp.Value))
              .map(stg => {
                stg.Selected = false;
                return stg;
              }));

            result.Value.Convention.Stages = result.Value.Convention.Stages.concat(pClient.Conventions[pIndex].Stages
              .filter(stg => !result.Value.Convention.Stages.find(selected => selected.Value == stg.Value))
              .map(stg => {
                stg.Selected = false;
                return stg;
              }));

            result.Value.Convention.generating = pClient.Conventions[pIndex].generating;

            pClient.Conventions[pIndex] = result.Value.Convention;

            this.http.getHttp<QResult<CalculConventionData>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/GET_CALCUL_CVT/${pClient.Conventions[pIndex].Ident}|${this.stageService.Stage.Ident}|${this.client.Ident}`).subscribe(
              (calculatedCvt: QResult<CalculConventionData>) => {
                pClient.Conventions[pIndex].displayed = true;
                pClient.Conventions[pIndex].showbuttongenerate = (!!pClient.Conventions[pIndex].IdEntiteFact && pClient.Conventions[pIndex].IdEntiteFact != '0');
                pClient.NbConventions = pClient?.Conventions ? pClient.Conventions.filter(c => c.Ident && c.Ident != '0').length : 0;
                pClient.Conventions[pIndex].MontantConvention = calculatedCvt.Value.Convention.MontantConvention;
                pClient.MontantConventions = calculatedCvt.Value.MontantConvention;
                this.dynamictagsInline.Load().subscribe();
                pClient.Conventions[pIndex].saving = false;

                if (pGeneration) {
                  const stageDocumentUpdate: StageDocumentUpdate = new StageDocumentUpdate();
                  stageDocumentUpdate.DocumentIdentList = [pClient.Conventions[pIndex].Ident];
                  stageDocumentUpdate.StringData = model.IdStageLinked;
                  stageDocumentUpdate.TypeDocument = "CONVENTION";
                  this.http.postHttp<QResult<boolean>>(`${this.indParam.AppParams.apiUrl}api/StageDocumentUpdate/GENERATE/Convention`, stageDocumentUpdate).subscribe(
                    (generationResult: QResult<boolean>) => {
                      pClient.Conventions[pIndex].FileExist = generationResult.Value;
                      pClient.Conventions[pIndex].generating = false;
                    });
                }
              });
          });
          //#endregion
        } else {
          if (pGeneration) pClient.Conventions[pIndex].generating = false;
          else pClient.Conventions[pIndex].saving = false;
        }

      });
    }
  }

  /**
   * mode de génération automatique de facture
   * @param cvt convention
   * @param pIndex index de la convention dans la liste des conventions du client
   */
  public GenerateLigneFacture(pClient: ClientConvention, cvt: ConventionData, pIndex: number,): void {
    //#region controle la validité de la convention avant génération
    if (!cvt)
      return;

    if (!cvt.Ident || cvt.Ident == '0') {
      this.toast.showWarningToast('Veuillez Générer la convention');
      return;
    }

    if (!pClient.Conventions[pIndex].showbuttongenerate) {
      this.toast.showWarningToast('Veuillez sauvegarder la convention avec une entité de facturation');
      return;
    }
    const stages = cvt.Stages.filter(stage => stage.Selected);
    if (stages && stages.length > 0) {
      this.toast.showWarningToast('Impossible de générer automatiquement la ligne de facture pour une convention multi-stages');
      return;
    }
    this.convention.generatingFact = true;
    //#endregion
    this.http.getHttp<ModeFacturationModel>(`${this.indParam.AppParams.apiUrl}api/spefCompta/modeFacturation/CREATE_LIGNE_AUTO_CVT/${cvt.Ident}`).subscribe((result: ModeFacturationModel) => {
      this.http.getHttp<QResult<ConventionData>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/GET_DATA_FACTURATION/${cvt.Ident}`).subscribe((result: QResult<ConventionData>) => {
        pClient.Conventions[pIndex].Factures = result.Value.Factures;
        pClient.Conventions[pIndex].MontantFactureHt = result.Value.MontantFactureHt;
        pClient.Conventions[pIndex].MontantFactureTTC = result.Value.MontantFactureTTC;
        this.convention.generatingFact = false;
      });
    });
  }

  /**
   * Sauvegarde EtatDOC, 
   * @param cvt
   * @param pIndex
   * @param pEtatDoc
   */
  public OnSaveEtatConvention(pClient: ClientConvention, cvt: ConventionData, pIndex: number, pEtatDoc: string): void {
    const model: ConventionData = JSON.parse(JSON.stringify(cvt));
    model.CodeEtatDoc = pEtatDoc;
    pClient.Conventions[pIndex].savingThumb = true;
    this.http.postHttp<QResult<ConventionData>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/SET_ETAT_CONVENTION`, model).subscribe((result: QResult<ConventionData>) => {
      if (!result.HasError) {
        result.Value.displayed = true;
        pClient.Conventions[pIndex] = result.Value;
      }
      pClient.Conventions[pIndex].savingThumb = false;
    });
  }

  /**
   * Quand le financeur change
   * @param convention
   * @param pCustomer
   */
  public ChangeFinanceur(pClient: ClientConvention, pConvention: ConventionData, pCustomer: QueovalItem): void {
    //si il n'y a pas de financeur, financeur égal donneur d'ordre
    if (!pCustomer || pCustomer.Value == 'DELETE') {
      if (!pConvention?.Financeur)
        pConvention.Financeur = new Corporation();
      pConvention.Financeur.Id = pClient.Ident;
      pConvention.Financeur.SocialReason = pClient.RaisoCli;
      return;
    }

    if (!pConvention.Financeur)
      pConvention.Financeur = new Corporation();
    pConvention.Financeur.Id = pCustomer.Value;
    pConvention.Financeur.SocialReason = pCustomer.Text;
  }

  /**
   * téléchargement des documents
   * @param pIdent
   * @param pExtension pdf ou docx selon le format souhaité
   */
  public UploadDoc(pIdent: string, pName: string, pExtension: string) {
    const fileModel: FileModel = new FileModel();
    fileModel.Ident = pIdent;
    fileModel.Extension = pExtension;
    fileModel.Name = pIdent;
    fileModel.DisplayName = pName;
    fileModel.DownloadMode = 'DOCXGENERE';
    this.fileService.downloadFile(fileModel);
  }

  /**
   * Ouverture de la modal de changement du document
   * @param content
   * @param convention
   */
  public openUploadDocument(content: any, convention: ConventionData) {
    this.insertDocModel.IdDonneeFils = convention.Ident;
    this.modalService.open(content, { size: 'xl', centered: true, windowClass: 'qmodalover' }).result.then((result) => {
      switch (result) {
        case 'SAVE': convention.FileExist = true; break;
        //  case 'CANCEL': this.closeConfigSignature(); break;
      }
    });
  }

  /**
   * vérifie si dans la liste il existe des éléments avec la valeur selected passée en paramètre
   * @param List
   * @param selected
   */
  public CheckList(List: Array<any>, selected: boolean = true): boolean {
    return selected ? List && List.some(cnt => cnt.Selected) : !List || List.some(cnt => !cnt.Selected);
  }

  // Ouverture de la modal pour consulter/update le bo de la convention
  public openBoConvention(Modal: any, pConvention: ConventionData) {
    this.modelBOConvention.IdDonneeFils = pConvention.Ident;
    this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' }).result.then((result) => {
      switch (result) {
        case 'SAVE': break;
        case 'CANCEL': break;
      }
    });
  }

  // Ouverture de la modal pour créer le bo du financeur
  public openBoFinanceur(Modal: any) {
    this.modelBOFinanceur.CodeRelation = "REL_BO_CENT_BO_CSOC";
    this.modelBOFinanceur.IdDonneePere = "1348";
    this.modelBOFinanceur.IdDonneeFils = "0";
    this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' }).result.then((result) => {
      switch (result) {
        case 'SAVE': break;
        case 'CANCEL': break;
      }
    });
  }

  // Ouverture de la modal pour créer le bo du responsable d'inscription
  public openBoRespInscription(Modal: any) {
    this.modelBORespInscription.CodeRelation = "REL_BO_CSOC_BO_DIRIGEANT";
    this.modelBORespInscription.IdDonneePere = this.client.Ident;
    this.modelBORespInscription.IdDonneeFils = "0";
    this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' }).result.then((result) => {
      switch (result) {
        case 'SAVE':
          break;
        case 'CANCEL':
          break;
      }
    });

  }

  // Ouverture de la modal pour créer le bo du responsable d'inscription
  public openBoFindFinanceur(Modal: any) {
    //#region Init BO_Financeur    
    this.http.getHttp<QResult<BObjectModel>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/GET_SEARCH_BO/0`).subscribe(
      (modelBo: QResult<BObjectModel>) => {
        this.modelBORechercheFinanceur = modelBo.Value;

        this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' }).result.then((result) => {
          switch (result) {
            case 'SAVE':
              break;
            case 'CANCEL':
              break;
          }
        });
      });
    //#endregion  
  }

  /**
  * récupere la liste des financeurs de la recherche avancée et affecte le premier financeur de la liste à la convention
   * @param lstFinanceur liste des financeurs 
   */
  public GetListFinanceur(lstFinanceur: Array<Select>) {
    if (lstFinanceur.length > 0) {
      // recharge le composant de recherche des financeurs
      this.convention.Financeur.Id = lstFinanceur[0].id;
      this.convention.Financeur.SocialReason = lstFinanceur[0].value;
    }
  }

  // Ouverture de la modal de confirmation de suppression de la convention
  public ConfirmDelete(Modal: any, pIndex: number) {
    if ([this.etatDOC.SIGNE, this.etatDOC.ANNULE].includes(this.client.Conventions[pIndex].CodeEtatDoc))
      return;

    this.indexConvToDelete = pIndex;
    this.modalService.open(Modal, { centered: true, windowClass: 'qmodalover' }).result.then((result) => {
      switch (result) {
        case 'SAVE': break;
        case 'CANCEL': break;
      }
    });
  }

  // Ouverture de la modale de signature electronique   
  public OpenESignature(Modal: any, cvt: ConventionData) {
    this.idConvention = cvt.Ident;
    this.modalService.open(Modal, { centered: true, size: 'q-xxl', windowClass: 'qmodalover' }).result.then((result) => {
      switch (result) {
        case 'SAVE':
          break;
        case 'CANCEL':
          break;
      }
    });
  }


  /**
   * Après la sauvegarde du BO récupération des inputs du modèle
   * @param pBoModel
   */
  public OnSaveBo(pBoModel: BObjectModel): void {
    this.indParam.showSplash(true);
    this.http.getHttp<QResult<CalculConventionData>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/GET_CALCUL_CVT/${this.convention.Ident}|${this.stageService.Stage.Ident}|${this.client.Ident}`).subscribe(
      (result: QResult<CalculConventionData>) => {
        this.convention.MontantConvention = result.Value.Convention.MontantConvention;
        this.client.MontantConventions = result.Value.MontantConvention;
        this.indParam.showSplash(false);
      });

    this.dynamictagsInline.Load().subscribe()
    //#region récupération des indexs des inputs du modèle
    const TitreDOC: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'titredoc' });
    const Info_DOC: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'info_doc' });
    const NuAccDOC: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'nuaccdoc' });
    const DossiDOC: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'dossidoc' });
    const MtTTCDOC: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'mtttcdoc' });
    const Etat_DOC: BObjectSummary[] = pBoModel.summary.filter((summary: BObjectSummary) => { return summary.ColumnName.toLowerCase() == 'etat_doc' });
    //#endregion
    if (TitreDOC?.length > 0) {
      this.convention.Titre = pBoModel.Body.SelectedGroupsList[TitreDOC[0].IndexGroupsList].DataList[TitreDOC[0].IndexDataList].MainElementList[0].Value;
    }
    if (Info_DOC?.length > 0) {
      this.convention.Info = pBoModel.Body.SelectedGroupsList[Info_DOC[0].IndexGroupsList].DataList[Info_DOC[0].IndexDataList].MainElementList[0].Value;
    }
    if (NuAccDOC?.length > 0) {
      this.convention.NumAccord = pBoModel.Body.SelectedGroupsList[NuAccDOC[0].IndexGroupsList].DataList[NuAccDOC[0].IndexDataList].MainElementList[0].Value;
    }
    if (MtTTCDOC?.length > 0) {
      const montant: number | undefined = parseInt(pBoModel.Body.SelectedGroupsList[MtTTCDOC[0].IndexGroupsList].DataList[MtTTCDOC[0].IndexDataList].MainElementList[0].Value);
      if (!isNaN(montant))
        this.convention.MontantConvention = montant;
    }
    if (DossiDOC?.length > 0) {
      const htmlBase: HtmlBase = pBoModel.Body.SelectedGroupsList[DossiDOC[0].IndexGroupsList].DataList[DossiDOC[0].IndexDataList].MainElementList[0];
      this.convention.IdentDossier = htmlBase.Value;
      if (htmlBase.SelectOptionsList?.length > 0)
        this.convention.IdentDossier = htmlBase.SelectOptionsList.find(option => option.Selected)?.Value ?? '';
    }
    if (Etat_DOC?.length > 0) {
      const htmlBase: HtmlBase = pBoModel.Body.SelectedGroupsList[Etat_DOC[0].IndexGroupsList].DataList[Etat_DOC[0].IndexDataList].MainElementList[0];
      this.convention.CodeEtatDoc = htmlBase.Value;
      if (htmlBase.SelectOptionsList?.length > 0)
        this.convention.CodeEtatDoc = htmlBase.SelectOptionsList.find(option => option.Selected)?.Value ?? '';
    }
  }
  /**
   * Ajoute le responsable à la liste aprés la sauvegarde du bo
   * @param pBoModel données du bo responsable après l'enregistrement
   */
  public OnSaveBoResponsable(pBoModel: BObjectModel): void {
    const identResponsable: string = pBoModel.IdDonneeFils;
    if (identResponsable) {
      this.http.getHttp<QResult<ConventionApprenantData>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/GET_RESPONSABLE/${identResponsable}`).subscribe((result: QResult<ConventionApprenantData>) => {
        if (!result.HasError) {
          result.Value.Selected = true;
          this.convention.Responsables.push(result.Value);
        }
      });
    }
  }
  /**
   * redirection vers la facturation
   * @param pIdCvt ident convention
   * @param pIdCli ident client
   * @param pIdRelation REL_BO_CSOC_BO_CVT
   * @param pMode mode de facturation à ouvrir (1 pour rapide, 0 pour détaillée)
   */
  public OpenFact(pClient: ClientConvention, pConvention: ConventionData, pIdCvt: string, pIdCli: string, pIdRelation: string, pMode: number): void {
    this.UpdateCurrentBreadCrumb(pClient.Ident, pConvention.Ident);
    //#region redirection vers la facturation
    const param: QueovalParam = new QueovalParam();
    if (pMode == 1)
      param.params.push({ key: 'params', value: `MODE=1&IDBO=BO_CVT&IDFILS=${pIdCvt}&IDPERE=${pIdCli}&IDRELATION=${pIdRelation}` });
    else
      param.params.push({ key: 'params', value: `IDBO=BO_CVT&IDFILS=${pIdCvt}&IDPERE=${pIdCli}&IDRELATION=${pIdRelation}` });

    this.modalService.dismissAll();
    this.breadCrumb.call(new BreadcrumbModel('add', 'view/facturation/mode-facturation', param, 'Mode de facturation automatique', false));
    //#endregion
  }

  /**
   * vérou sur le bouton de génération automatique de la facturation
   * @param pConvention
   */
  public DisabledGenerationAuto(pConvention: ConventionData): boolean {
    return (pConvention.MontantFactureHt && pConvention.MontantFactureHt > 0) || !pConvention.showbuttongenerate || (pConvention.Stages && pConvention.Stages.filter(stage => stage.Selected).length > 0);
  }
  /**
   * somme les montants d'une liste de FactureConvention suivant le mode donné
   * @param pFactures
   * @param pmode MontantTTC ou RestantDu
   */
  public SummMtFact(pFactures: Facture[], pmode: string): number {
    switch (pmode) {
      case 'MontantTTC':
        const sumTTC = pFactures.reduce((partialSum: number, facture: Facture) => partialSum + facture.MontantTTC, 0);
        return sumTTC;
        break;
      case 'RestantDu':
        const sumRest = pFactures.reduce((partialSum: number, facture: Facture) => partialSum + facture.RestantDu, 0);
        return sumRest;
        break;
    }
    return 0;
  }

  /**
   * redirection vers la facturation de la ligne sélectionnée
   * @param pIdFact
   */
  public OpenLigneFact(pClient: ClientConvention, pConvention: ConventionData, pIdFact: string): void {
    this.UpdateCurrentBreadCrumb(pClient.Ident, pConvention.Ident);
    const param: QueovalParam = new QueovalParam();
    param.params.push({ key: 'params', value: `infoValid=${pIdFact}` });
    const modeFacturationModel: ModeFacturationModel = new ModeFacturationModel();
    this.facturationservice.modeFacturationModel = modeFacturationModel;
    //chargement des données de la page à partir de l'ident de la facture
    this.facturationservice.loadFacture(pIdFact).subscribe(
      (res: boolean) => {
        if (res) {
          //redirection
          localStorage.setItem('preparationFacture', JSON.stringify(modeFacturationModel.formulaire));
          localStorage.setItem('preparationFactureFilter', '||||');

          this.modalService.dismissAll();
          this.breadCrumb.call(new BreadcrumbModel('add', 'view/facturation/mode-facturation', param, 'Visualisez/Modifiez factures', false));
        }
      });
  }

  public FacturationFont(convention: ConventionData): string {
    if (!convention.Ident || convention.Ident == '0')
      return 'fa-times q-c-danger';
    if (convention.MontantFactureHt >= convention.MontantConvention)
      return 'fa-check q-c-success';
    if (convention.MontantFactureHt > 0) 
      return 'fa-exclamation-triangle q-c-warning';
    
    return 'fa-times q-c-danger';
  }

  public FacturationEcheancierFont(convention: ConventionData): string {
    if (convention.MontantFactureHt >= convention.MontantConvention)
      return 'fa-check q-c-success';
    if (convention.MontantFactureHt > 0)
      return 'fa-exclamation-triangle q-c-warning';
      
    return ''
  }

  public NomDossier(pIdDossier: string): string {
    const dossier: Select | undefined = this.conventionService.dossiers.find(dossier => dossier.id == pIdDossier)
    return dossier?.value ?? '';
  }
  /** retourne le nombre d'apprenants liés à la convention en se basant sur le nombre du groupe (prop NbGrpPER)*/
  public NbApprenants(): number {
    return this.convention.Apprenants.filter(app => app.Selected).reduce((prev: number, app: ConventionApprenantData) => prev += app.Count, 0);
  }


  public RemoveElementList(pElement: ConventionStageData | ConventionApprenantData | QueovalItem, pCode: string): void {
    switch (pCode) {
      case 'STAGE':
        this.RemoveStage(pElement as ConventionStageData);
        break;
      case 'APPRENANT':
      case 'RESPONSABLE':
        pElement.Selected = false;
        break;
    }
  }

  /**
   * Retire les apprenants d'un stage de la liste des apprenants lorsque le stage est déselectionné
   * @param pStage stage retiré
   * @param pIsStage appelé sur les 3 listes (stage, apprenant, responsable inscription)
   */
  public RemoveStage(pStage: ConventionStageData): void {
    if (pStage.Apprenants && pStage.Apprenants.length > 0) {
      const appToRemove: string[] = pStage.Apprenants.filter(app => {
        for (let i: number = 0; i < this.convention.Stages.length; i++) {
          const stage: ConventionStageData = this.convention.Stages[i];
          if (stage.Selected && stage.Value != pStage.Value) {
            if (stage.Apprenants.some(stgApp => stgApp.Value == app.Value)) {
              return false;
            }
          }
        };
        return this.apprenants.findIndex(keeped => keeped.Value == app.Value) == -1
      }).map(toRemove => toRemove.Value);
      this.convention.Apprenants = this.convention.Apprenants.filter(app => !appToRemove.includes(app.Value));
    }
    pStage.Selected = false;
  }

  public AddElementList(pElement: ConventionStageData | ConventionApprenantData | QueovalItem, pCode: string): void {
    switch (pCode) {
      case 'STAGE':
        this.AddStage(pElement as ConventionStageData);
        break;
      case 'APPRENANT':
        pElement.Selected = true;
        break;
      case 'RESPONSABLE':
        this.convention.Responsables.map(resp => resp.Selected = false);
        pElement.Selected = true;
        break;
    }
  }

  /**
   * Ajoute les apprenants d'un stage à la liste des apprenants lorsque le stage est sélectionné
   * @param pStage stage ajouté
   * @param pIsStage appelé sur les 3 listes (stage, apprenant, responsable inscription)
   */
  public AddStage(pStage: ConventionStageData): void {
    pStage.Selected = true;
    if (pStage.ApprenantsLoaded) { this._AddStage(pStage); }
    else {
      this.http.getHttp<QResult<Array<ConventionApprenantData>>>(`${this.indParam.AppParams.apiUrl}api/Stage/Convention/Apprenants/${pStage.Value}/${this.client.Ident}`).subscribe(
        (result: QResult<Array<ConventionApprenantData>>) => {
          pStage.Apprenants = result.Value;
          pStage.ApprenantsLoaded = true;
          this._AddStage(pStage);
        });
    }
  }

  private _AddStage(pStage: ConventionStageData): void {
    if (pStage.Apprenants && pStage.Apprenants.length > 0) {
      //ajoute les apprenants ne faisants pas doublons àla liste
      const addedAppIdents: string[] = this.apprenants.map(app => app.Value);
      pStage.Apprenants.forEach(appToAdd => {
        if ((!this.apprenants || this.apprenants.length == 0 || !addedAppIdents.includes(appToAdd.Value)) && !this.convention.Apprenants.some(app => app.Value == appToAdd.Value)) {
          appToAdd.Selected = false;
          // Ajout du stage sur l'apprenant pour l'indiquer en info
          appToAdd.TxtStageApprenant = pStage.Text;
          this.convention.Apprenants.push(appToAdd);
        }
      });
      this.convention.Apprenants.sort((a: QueovalItem, b: QueovalItem) => a.Text.toLowerCase().localeCompare(b.Text.toLowerCase()));
    }   
  }

  public AddAllApprenants(): void {
    this.convention.Apprenants.forEach(app => app.Selected = true);
  }

  public RemoveAllApprenants(): void {
    this.convention.Apprenants.forEach(app => app.Selected = false);
  }


  public OnScroll(e:any): void {
      this.popoverWidth = $('cdk-virtual-scroll-viewport hr').width() ? ($('cdk-virtual-scroll-viewport hr').width() as number) + 10 : 0;
  }

  public RefreshVirtualScrollListener(): void {
    this.popoverWidth = 0;
    setTimeout(() => {
      this.popoverWidth = $('cdk-virtual-scroll-viewport hr').width() ? ($('cdk-virtual-scroll-viewport hr').width() as number) + 10 : 0;
    }, 0);
  }
  private UpdateCurrentBreadCrumb(pIdClient: string, pIdConvention: string): void {
    //#region modification du breadcrumb actuel pour que la route ouvre le stage-detail sur l'ongle convention avec le client séléctionné
    const oldBreadcrumb = this.breadCrumb.Breadcrumb[this.breadCrumb.Breadcrumb.length - 1];
    const currentBread = new BreadcrumbModel('add', oldBreadcrumb.link, JSON.parse(JSON.stringify(oldBreadcrumb.data)), oldBreadcrumb.title, true);

    //regarde si l'élément précédent dans le BC est le detail du stage
    const indexOfDetail = currentBread.link.indexOf('/stage-detail');
    let link: string = '';
    if (indexOfDetail == -1) {
      link = 'view/formations/stage-detail';
    } else {
      link = currentBread.link.slice(0, indexOfDetail + 13);
    }
    //modifie le lien pour ouvrir directement le détail du stage sur la convention avec les 'current' client et convention => ouverts
    currentBread.link = `${link}/${this.stageService.Stage.Ident}/convention`;

    currentBread.data.params = [];
    currentBread.data.params.push(new BreadDik('idClient', pIdClient));
    currentBread.data.params.push(new BreadDik('idConvention', pIdConvention));

    //si l'élément précédent dans le BC est le detail du stage on le remplace ;
    //sinon ou pousse un nouvel élément dans le BC sans modifier le précédent
    if (indexOfDetail == -1) {
      currentBread.title = 'Convention du stage';
      this.breadCrumb.Breadcrumb.push(currentBread);
    } else {
      currentBread.params = oldBreadcrumb.params;
      this.breadCrumb.Breadcrumb[this.breadCrumb.Breadcrumb.length - 1] = currentBread;
    }
    //#endregion
  }
}
